import * as React from "react";
import Link from "next-shims/Link";
import { Box, Chip, Stack, Typography, Paper } from "@mui/material";
import type { PropertyCardItem } from "./PropertyCard";

function absUrl(path?: string | null) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${p}` : p; // αν δεν έχεις base, αφήνει relative
}

export default function PropertyRow({
  locale,
  property,
}: {
  locale: string;
  property: PropertyCardItem;
}) {
  const href = `/${locale}/properties/${property.slug}`;
  const badge = String(property.listing_status || "").includes("sale")
    ? "Πώληση"
    : "Ενοικίαση";

  const coverSrc = absUrl(property.coverImage);

  return (
    <Paper
      component={Link}
      href={href}
      sx={{
        textDecoration: "none",
        color: "inherit",
        p: 1.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        display: "grid",
        gap: 12,
        gridTemplateColumns: { xs: "100px 1fr", sm: "140px 1fr" },
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: 80, sm: 95 },
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "grey.100",
        }}
      >
        {coverSrc ? (
          <Box
            component="img"
            src={coverSrc}
            alt={property.display_title}
            loading="lazy"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : null}
      </Box>

      <Box sx={{ minWidth: 0 }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography sx={{ fontWeight: 800, lineHeight: 1.2 }} noWrap>
            {property.display_title}
          </Typography>
          <Chip size="small" label={badge} />
        </Stack>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          {[property.city, property.region].filter(Boolean).join(", ")}
        </Typography>

        <Stack direction="row" spacing={1} sx={{ mt: 0.8 }} flexWrap="wrap" useFlexGap>
          {property.bedrooms != null ? (
            <Chip size="small" label={`${property.bedrooms} υπν.`} />
          ) : null}
          {property.size_m2 != null ? (
            <Chip size="small" label={`${property.size_m2} m²`} />
          ) : null}
        </Stack>
      </Box>
    </Paper>
  );
}
